import PageHeader from "@/components/layout/PageHeader";
import ReviewsSection from "@/components/home/ReviewsSection";

export default function Reviews() {
  return (
    <>
      <PageHeader
        eyebrow="Reviews"
        title="What customers say about us."
        subtitle="We rely on genuine Google reviews from our real customers — nothing is fabricated on this page."
      />
      <ReviewsSection />
    </>
  );
}
